import React, { useState, useEffect, useContext } from 'react';
import { useParams, useSearchParams } from "react-router-dom";
import './interviewanalysis.css';
import { UserTypeContext } from "../../AppRoute";
import CandidateAnalysis from '../../components/candidateanalysis/candidateanalysis';
import CandidateAnalysisAi from '../../components/candidateanalysisai/candidateanalysisai';

const InterviewAnalysis = () => {
  const { id } = useParams();
  const { userRecords } = useContext(UserTypeContext);
const [searchParams] = useSearchParams();
const interviewType = searchParams.get("int") === "vet";

  if(interviewType){
    return <CandidateAnalysis id={id} userRecords={userRecords} />
  }
  else
  {
    return <CandidateAnalysisAi id={id} userRecords={userRecords} />
  }


};

export default InterviewAnalysis;
